import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/Input';

interface PatientSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

export function PatientSearch({
  value,
  onChange,
  placeholder = 'Search patients...',
  disabled = false,
}: PatientSearchProps) {
  return (
    <div className="relative max-w-md">
      <Input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        leftIcon={<Search className="h-4 w-4" />}
        rightIcon={
          value ? (
            <button
              type="button"
              onClick={() => onChange('')}
              className="rounded p-0.5 hover:bg-gray-100"
              aria-label="Clear search"
            >
              <X className="h-4 w-4" />
            </button>
          ) : undefined
        }
        disabled={disabled}
      />
    </div>
  );
}
